// extracted by mini-css-extract-plugin
module.exports = {"image":"Featurette_image__4jXFX"};